import { render, staticRenderFns } from "./ProgressReportDepartments.vue?vue&type=template&id=10b93503&"
import script from "./ProgressReportDepartments.vue?vue&type=script&lang=js&"
export * from "./ProgressReportDepartments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b93503')) {
      api.createRecord('10b93503', component.options)
    } else {
      api.reload('10b93503', component.options)
    }
    module.hot.accept("./ProgressReportDepartments.vue?vue&type=template&id=10b93503&", function () {
      api.rerender('10b93503', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/graduationProgress/ProgressReportDepartments.vue"
export default component.exports